module.exports = __webpack_public_path__ + "static/img/map.4ff946e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map.png
// module id = 9i06
// module chunks = 1